import { Tickets } from "../../../components/TicketsPanel/Tickets";
import normalIcon from "./icons/normal.png";
import activeIcon from "./icons/active.png";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "../../../hooks";
import styles from "./WorkButton.module.scss";
import { convertEnergy } from "../../../redux/work/convert-enegry.handler";
import { Highlightable } from "../../../components/Highlight/Highlightable";
import { ActionPromptType } from "../../../hooks/prompts";

const icons = {
    normal: normalIcon,
    active: activeIcon,
};

const REGULAR_TICKETRS_RATE = 0.00001;
const RARE_TICKETRS_RATE = 0.000001;

export const WorkButton = () => {
    const [isActive, setIsActive] = useState(false);
    const [isBusy, setIsBusy] = useState(false);
    const [tickets, setTickets] = useState([0, 0]);
    const convertInFlightRef = useRef(false);
    const dispatch = useDispatch();

    const currentEnergy = useSelector(store => store.work.currentEvergy);

    const pressButtonHandler = async () => {
        if (convertInFlightRef.current)
            return;

        convertInFlightRef.current = true;
        setIsBusy(true);
        setIsActive((prev) => !prev);

        try {
            const resultAction = await dispatch(convertEnergy());

            const canVibrate = ('vibrate' in navigator);
            if (canVibrate)
                window.navigator.vibrate(80);

            if (convertEnergy.fulfilled.match(resultAction))
                setTimeout(() => setIsActive((prev) => !prev), 500);
        }
        finally {
            convertInFlightRef.current = false;
            setIsBusy(false);
        }
    };

    useEffect(() => {
        const calc = (rate: number) => Math.floor(rate * currentEnergy * 100) / 100;
        
        const regularTickets = calc(REGULAR_TICKETRS_RATE);
        const rareTickets = calc(RARE_TICKETRS_RATE);

        setTickets([regularTickets, rareTickets]);
    }, [currentEnergy]);

    return (
        <Highlightable promptType={ ActionPromptType.CONVERT_ENERGY_FIRST_TIME } highlightClass={ styles.highlight } >
            <div
                className={`${styles.circleButton}${isBusy ? ` ${styles.circleButtonBusy}` : ""}`}
                onClick={pressButtonHandler}
                aria-busy={isBusy}
            >
                <img
                    src={isActive ? icons.active : icons.normal}
                    alt="Circle Button"
                    className={styles.circleImage}
                />
                <div className={styles.getSalary}>
                    <div className={styles.getSalaryText}>
                        <div>Получить</div>
                        <div>зарплату</div>
                    </div>

                    <div className={styles.tickets}>
                        <Tickets {...{ regularTickets: tickets[0], rareTickets: tickets[1] }} context='work-button' prefix='+' />
                    </div>
                </div>
            </div>            
        </Highlightable>
    );
}